import * as React from 'react';
const SmallLocator = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <mask
      id="a"
      width={18}
      height={18}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#171717"
        d="M9 15.705c-.146 0-.292-.025-.438-.075a1.158 1.158 0 0 1-.397-.235 27.573 27.573 0 0 1-1.89-1.916 17.175 17.175 0 0 1-1.53-1.97 10.524 10.524 0 0 1-1.027-1.954c-.253-.645-.379-1.268-.379-1.869 0-1.73.56-3.132 1.68-4.204C6.139 2.411 7.465 1.875 9 1.875c1.535 0 2.862.536 3.982 1.607 1.12 1.072 1.679 2.473 1.679 4.204 0 .601-.126 1.223-.379 1.866a10.805 10.805 0 0 1-1.024 1.953c-.431.659-.94 1.316-1.526 1.97a28.023 28.023 0 0 1-1.89 1.913 1.17 1.17 0 0 1-.397.238c-.148.053-.297.08-.445.08ZM9.001 8.9c.373 0 .693-.133.957-.399.265-.265.398-.585.398-.958s-.133-.692-.399-.957A1.309 1.309 0 0 0 9 6.188c-.373 0-.693.132-.957.398a1.309 1.309 0 0 0-.398.959c0 .373.133.692.399.957s.585.397.958.397Z"
      />
    </g>
  </svg>
);
export default SmallLocator;
